import { render } from "./TrainingMilestoneModel.vue?vue&type=template&id=0b791a1b&ts=true"
import script from "./TrainingMilestoneModel.vue?vue&type=script&lang=ts"
export * from "./TrainingMilestoneModel.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__